<template>
	<el-dialog width="700px" :title="title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
		<el-form :model="form" label-width="80px">
			<el-form-item v-for="(item, index) in formHead" :key="index" :label="item.chfieldName">
				<el-input
					size="medium"
					v-model="form[item.enfieldName]"
					autocomplete="off"
				></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer" v-if="!disabled">
			<el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
			<el-button size="medium" type="primary" @click="editData">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		fieldContrast: {
			type: Array
		}
	},

	data() {
		return {
			id: '',
			dialogFormVisible: false,
			disabled: false,
			title: '查看详情',
			form: {},
			formHead: []
		};
	},
	created() {},
	methods: {
		editData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.modifyOneSample}`,
				method: 'POST',
				data: {
					sampleModifyValue: this.form,
					id: this.form.id,
					qid: this.id
				},
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.$emit('eidtOK');
						that.dialogFormVisible = false;
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		loadData() {
			this.id = this.$route.query.id;
			this.formHead = this.fieldContrast.filter(item => {
				if (item.isSysField != 1 || item.enfieldName == 'phone' || item.enfieldName == 'piAreaCode' || item.enfieldName == 'piExt') {
					return true
				}
			})
			this.dialogFormVisible = true;
		}
	}
};
</script>

<style></style>
